export default "__VITE_ASSET__Ccnp8QXN__"